import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class Countercharge extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 30,
            duration: 7,
            energyCost: 40,
            icon: 5,
            trigger: KeyCode.Digit3,
            triggerType: Input.GetKeyDown,
            info: `Countercharge (30s cooldown) - Reflect 20% of all damage taken back at attackers for 7 seconds`
        })
    }

    reflectDmg = ({amount, from}: {
        amount: number;
        from?: string;
    }) => {
        const player = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(v => v.gameObject.id === from)[0];
        
        if (player) this.player.engine.sendDamagePacket(player, Math.floor(amount * 0.2));
    }

    onDurationEnd(): void {
        this.player.listeners.off("damage-taken", this.reflectDmg);
    }

    onUse(): void {
        this.player.listeners.on("damage-taken", this.reflectDmg);
    }

}